import { render } from "./MovieItem.vue?vue&type=template&id=5e398100&scoped=true"
import script from "./MovieItem.vue?vue&type=script&lang=js"
export * from "./MovieItem.vue?vue&type=script&lang=js"

import "./MovieItem.vue?vue&type=style&index=0&id=5e398100&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_0435b427d4926b97c683d68ac9fd935c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e398100"]])

export default __exports__